export type PhotoConclusionInput = {
  culpritTool: string
  region: string
  onsetLot: string
  missingRows: string
  unitErrorRows: string
  duplicateRows: string
  decoyReason: string
}

export function buildPhotoConclusion(input: PhotoConclusionInput) {
  return {
    culprit_tool: input.culpritTool,
    region: input.region,
    onset_lot: input.onsetLot,
    missing_rows: input.missingRows,
    unit_error_rows: input.unitErrorRows,
    duplicate_rows: input.duplicateRows,
    decoy_reason: input.decoyReason,
  }
}

export function formatScore(score: number, maxScore = 100) {
  return `${score}/${maxScore}`
}

export function competencyRatio(score: number, maxScore: number) {
  if (maxScore <= 0) return 0
  return Math.min(1, Math.max(0, score / maxScore))
}
